<ngrx-busy>
  <form [formGroup]="form"
    (ngSubmit)="save()"
    class="side-form">
    <h3>Upload animations</h3>

    <mat-form-field appearance="fill"
      class="file-field"
      (click)="!uploading && fileInput.click()">
      <mat-label>File</mat-label>
      <input matInput
        [value]="selectedFile"
        [disabled]="uploading"
        readonly>
      <input #fileInput
        hidden
        type="file"
        accept=".zip,application/zip,application/x-zip-compressed"
        [disabled]="uploading"
        (change)="setFile(fileInput.files?.[0])">
      <mat-icon matSuffix>attach_file</mat-icon>
      <mat-hint>ZIP archive</mat-hint>
      @if (form.get('file').hasError('required')) {
        <mat-error>File is <strong>required</strong></mat-error>
      }
    </mat-form-field>

    <div class="side-form-actions">
      <button mat-raised-button
        type="submit"
        color="primary"
        [disabled]="uploading || form.get('file').invalid">
        Upload
      </button>
    </div>

    <app-form-error></app-form-error>
  </form>
</ngrx-busy>
